import React, { useState, useContext } from "react";
import ThreeYearReport from "./3YearReport";
import MiscCodes from "./Misccodes";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";
import AccountContext from "../../context/accounts/accountContext";
import IstavrityReport from "./IstavrityReport";
import Statewisereport from "./Statewisereport";

const Administration = (props) => {
  const accountContext = useContext(AccountContext);
  const { whitelistedCountries } = accountContext;
  const initialState = {
    showMiscCodeDiv: true,
    show3YearPlanDiv: false,
    showIstavrityReportDiv: false,
    country: "",
    region: "",
    showStatewiseReportDiv: false,
  };
  console.log("CountryRegionData: ", CountryRegionData);
  const countries = CountryRegionData.map(([name, shortCode]) => {
    return { name, shortCode };
  });
  console.log("All Countries: ", countries);
  const filtered = whitelistedCountries.length
    ? countries
        .filter((c) => whitelistedCountries.includes(c.shortCode))
        .map((c) => c.name)
    : countries.map((c) => c.name);
  console.log("Filtered Countries: ", filtered);
  const options = ["All", ...filtered];
  const [state, setState] = useState(initialState);
  const { showMiscCodeDiv, show3YearPlanDiv, showStatewiseReportDiv, country } = state;
  const onSelectDiv = (e) => {
    console.log(e.target.name);
    let newState = {
      showMiscCodeDiv: false,
      show3YearPlanDiv: false,
      showIstavrityReportDiv: false,
      showStatewiseReportDiv: false,
    };
    switch (e.target.name) {
      case "showMiscCodeDiv":
        newState.showMiscCodeDiv = true;
        break;
      case "show3YearPlanDiv":
        newState.show3YearPlanDiv = true;
        break;
      case "showIstavrityReportDiv":
        newState.showIstavrityReportDiv = true;
        break;
      case "showStatewiseReportDiv":
        newState.showStatewiseReportDiv = true;
        break;
      default:
        newState = initialState;
        break;
    }
    console.log(JSON.stringify(newState));
    setState({ ...state, ...newState });
  };

  const selectCountry = (val) => {
    console.log("Selected Country: ", val);
    setState({ ...state, country: val });
  };

  const selectRegion = (val) => setState({ ...state, region: val });

  return (
    <div className="uk-container">
      <ul uk-tab="true">
        <li className="uk-active">
          <a name="showMiscCodeDiv" onClick={onSelectDiv}>
            {" "}
            MISC CODES
          </a>
        </li>
        |
        <li>
          <a name="show3YearPlanDiv" onClick={onSelectDiv}>
            3 Year Report
          </a>
        </li>
        |
        <li>
          <a name="showIstavrityReportDiv" onClick={onSelectDiv}>
            Istavrity Report
          </a>
        </li>
        |
        <li>
          <a name="showStatewiseReportDiv" onClick={onSelectDiv}>
            Statewise Report
          </a>
        </li>
      </ul>
      <div className="uk-margin">
        <span className="uk-text-bold">Select Country:</span>
        <select value={country} onChange={(e) => selectCountry(e.target.value)}>
          <option value="">Select Country</option>
          {options.map((country) => (
            <option key={country} value={country}>
              {country}
            </option>
          ))}
        </select>
        {/* <CountryDropdown
          name="country"
          whitelist={whitelistedCountries}
          className="uk-select uk-text"
          value={country}
          onChange={(val) => selectCountry(val)}
          required={true}
        /> */}
        {state.showIstavrityReportDiv && (
          <div className="uk-margin-top">
            <span className="uk-text-bold">Select Region:</span>
            <RegionDropdown
              className="uk-select"
              country={country}
              value={state.region}
              onChange={(val) => selectRegion(val)}
            />
          </div>
        )}
      </div>

      <div className="uk-container ">
        {show3YearPlanDiv && (
          <div id="3yearreport">
            <ThreeYearReport country={country} />
          </div>
        )}

        {showMiscCodeDiv && country && (
          <div id="misccodes">
            <MiscCodes props={props} country={country} />
          </div>
        )}
        {state.showIstavrityReportDiv && (
          <IstavrityReport state={state.region} />
        )}
        {state.showStatewiseReportDiv && (
          <Statewisereport country={country} />
        )}
      </div>
    </div>
  );
};
export default Administration;
